import React from 'react'

import { DownloadBadgeStyled, DownloadBadgeIconStyled } from './styles'
import { IconDownload } from './../../../assets/svg/index'

interface DownloadBadgeProps {
  url: string
}

const DownloadBadge: React.FC<DownloadBadgeProps> = ({ url }) => {
  return (
    <DownloadBadgeStyled href={url} download>
      <DownloadBadgeIconStyled>
        <IconDownload />
      </DownloadBadgeIconStyled>
    </DownloadBadgeStyled>
  )
}

export default DownloadBadge
